import { styled } from 'styled-components';
import { renderFullPath } from '~/utils/common/utils';
import bgFirst from '@assets/images/background/bg-leaderboard-first.png';
import iconGold from '@assets/images/icon/icon-star-gold.png';
import iconArgent from '@assets/images/icon/icon-star-argent.png';
import iconBronze from '@assets/images/icon/icon-star-bronze.png';
import { classic } from '~/themes';

type IProps = {
  name: string;
  nb: number;
  position: number;
  avatarSrc?: string;
  size: 'lg' | 'md' | 'sm';
};

type TProps = IProps;

export function LeaderBoardHeadItem({
  position,
  avatarSrc,
  size,
  name,
  nb,
}: TProps) {
  return (
    <Container $position={nb} $background={bgFirst}>
      {avatarSrc && (
        <SDivAvatar $size={size}>
          <SImg src={renderFullPath(avatarSrc)} alt="" />
          {(nb === 0 || nb === 1 || nb === 2) && (
            <SDivIconStar $size={size}>
              {nb === 0 && <SIconStar $size={size} src={iconGold} alt="" />}
              {nb === 1 && <SIconStar $size={size} src={iconArgent} alt="" />}
              {nb === 2 && <SIconStar $size={size} src={iconBronze} alt="" />}
              <SIconSpan $position={nb}>{nb + 1}</SIconSpan>
            </SDivIconStar>
          )}
        </SDivAvatar>
      )}

      <SAvatarSpan>{name}</SAvatarSpan>
      <SAvatarSpan>
        {position}
        {' %'}
      </SAvatarSpan>
    </Container>
  );
}

const SIconSpan = styled.div<{ $position: number }>`
  font-family: 'Riffic Free', sans-serif;
  color: ${({ $position }) => {
    if ($position === 0) return '#C93F13';
    if ($position === 1) return '#6B6B6B';
    if ($position === 2) return '#985C49';
    return `${classic.token?.colorText}`;
  }};

  background-color: transparent;
  font-weight: bold;
  font-size: ${({ $position }) => {
    if ($position === 0) return '0.9rem';
    if ($position === 1) return '0.8rem';
    if ($position === 2) return '0.75rem';
    return `${classic.token?.colorText}`;
  }};

  @media screen and (max-width: 450px) {
    font-size: 0.7rem;
  }
  @media screen and (max-height: 800px) {
    font-size: 0.5rem;
  }
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const SDivIconStar = styled.div<{ $size?: 'lg' | 'md' | 'sm' }>`
  height: ${({ $size }) => {
    if ($size === 'lg') return '40px';
    if ($size === 'md') return '30px';
    if ($size === 'sm') return '26px';

    return '20px';
  }};
  width: ${({ $size }) => {
    if ($size === 'lg') return '40px';
    if ($size === 'md') return '30px';
    if ($size === 'sm') return '26px';

    return '20px';
  }};
  position: absolute;
  top: ${({ $size }) => {
    if ($size === 'lg') return '-22px';
    if ($size === 'md') return '-17px';
    if ($size === 'sm') return '-14px';

    return '-10px';
  }};
  left: 50%;
  transform: translateX(-50%);
`;

const SIconStar = styled.img<{ $size?: 'lg' | 'md' | 'sm' }>`
  position: absolute;
  object-fit: contain;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

const SAvatarSpan = styled.div`
  font-family: 'Riffic Free', sans-serif;
  color: ${classic.token?.colorWhite};
  background-color: transparent;
  font-weight: bold;
  font-size: 1.1rem;

  @media screen and (max-width: 450px) {
    font-size: 1rem;
  }
  @media screen and (max-height: 800px) {
    font-size: 1rem;
  }
`;

const Container = styled.div<{
  disabled?: boolean;
  $position: number;
  $background?: string;
}>`
  align-items: center;
  display: flex;
  background-image: ${({ $background, $position }) =>
    $background && $position === 0 ? `url('${$background}')` : 'none'};
  background-position: center;
  background-size: 100% 100%;
  justify-content: center;
  flex-direction: column;
  min-height: 75px;
  padding: 14px 14px 20px 14px;
  user-select: none;
  width: 100%;

  @media screen and (max-width: 450px) {
    min-height: 65px;
  }
`;

const SDivAvatar = styled.div<{ $size: 'lg' | 'md' | 'sm' }>`
  border-radius: 50%;
  background-color: #fff;
  height: ${({ $size }) => {
    if ($size === 'lg') return '64px';
    if ($size === 'md') return '52px';
    if ($size === 'sm') return '44px';

    return '40px';
  }};
  width: ${({ $size }) => {
    if ($size === 'lg') return '64px';
    if ($size === 'md') return '52px';
    if ($size === 'sm') return '44px';

    return '40px';
  }};
  margin-top: 20px;
  position: relative;
  border: 3px solid #fff;
`;

const SImg = styled.img`
  position: absolute;
  object-fit: contain;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;
// classic.token?.colorPrimary
/*
@media screen and (max-width: 300px) {
    @media screen and (max-width: 450px) {
    padding: calc(0.5rem + 6px) 5px 10px 5px;
  }
  @media screen and (max-height: 800px) {
    padding: calc(0.7rem + 10px) 24px;
  }
  }
*/
